import { connect } from 'react-redux';
import Scratchpad from './Scratchpad';
import { fetchScratchpad } from '../../redux/modules/scratchpad';

const mapStateToProps = ({
  scratchpad: { data, title, viewInScratchpad, viewInScratchpadABtestRecentActivityLinkText }
}) => ({
  data,
  title,
  viewInScratchpad,
  viewInScratchpadABtestRecentActivityLinkText
});

const mapDispatchToProps = {
  fetchScratchpad
};

export default connect(mapStateToProps, mapDispatchToProps)(Scratchpad);



// WEBPACK FOOTER //
// ./src/universal/components/Scratchpad/index.js